export default __webpack_public_path__ + "static/media/bestReviews.cf366c85.jpg";